const _ = require("lodash");
const diagramColors = require("../../util/ColorUtil").getDiagramColors();
const SplineUtil = require("../util/SplineUtil");

/**
 * Uses spline interpolation to draw a smooth curve connecting at least two points.
 *
 * @param {CanvasRenderingContext2D} ctx - context to use
 * @param {Array} vertices - array of points to connect
 * @param {Object} options - options for [tension=0.15], [numOfSeg], and [color="defaultBlack"]
 */
const encircle = (ctx, vertices, options = {}) => {
	if (_.isArray(vertices) && vertices.length < 2) {
		throw new Error("The vertices array must have at least 2 points");
	}
	if (!_.isArray(vertices)) {
		throw new Error(
			"Vertices must be an array of arrays denoting pixel coordinates"
		);
	}
	for (const vertex of vertices) {
		if (!_.isArray(vertex) || vertex.length !== 2) {
			throw new Error(
				"Each vertex must be represented by an array of length 2"
			);
		}
	}

	const opts = _.extend(
		{
			tension: 0.15,
			debug: false,
			// rest of defaults are in SplineUtil.curve()
			color: "defaultBlack",
			lineWidth: ctx.lineWidth,
		},
		options
	);
	const color = diagramColors[opts.color];
	if (!color) {
		throw new Error("Unrecognized color - please use a supported color");
	}

	// draw debug lines if wanted
	if (opts.debug) {
		ctx.save();
		if (!_.isNumber(opts.debug)) {
			// default step size
			opts.debug = 50;
		}

		ctx.setLineDash([5, 10]);
		for (let hLine = opts.debug; hLine < ctx.height; hLine += opts.debug) {
			ctx.moveTo(0, hLine);
			ctx.lineTo(ctx.width, hLine);
		}
		for (let vLine = opts.debug; vLine < ctx.width; vLine += opts.debug) {
			ctx.moveTo(vLine, 0);
			ctx.lineTo(vLine, ctx.height);
		}
		ctx.stroke();
		ctx.restore();
	}

	ctx.save();
	ctx.lineWidth = opts.lineWidth;

	SplineUtil.curve(ctx, _.flatten(vertices), opts);
	ctx.stroke(color);

	ctx.restore();
};

module.exports = encircle;
